import React from 'react';

import { cn } from '../lib/utils';

export function Skeleton({ className, children }: { className?: string; children?: React.ReactNode }) {
  return <span className={cn('animate-pulse rounded-md bg-gray-100', className)}>{children}</span>;
}
